import { createSlice } from "@reduxjs/toolkit";

const digitalSalesSlice = createSlice({
    name: 'digitalSalesReducer',
    initialState: {},
    reducers: {
        resetDigitalsSalesReducer: (state) => {
            return {}
        },
        updateDigitalSalesReducer: (state, action) => {
            return {
                ...state,
                ...action.payload
            }
        }
    },
})

export const {resetDigitalsSalesReducer,updateDigitalSalesReducer} = digitalSalesSlice.actions;

export default digitalSalesSlice.reducer;